export const PL_CORE_ENROLLMENT_SHORT_NAMES = {
	HP: "Health Plan"
	// DT: "Dental Plan",
	// VI: "Vision Plan"
};
